<template>
  <div :ref="modalId" class="modal fade" role="dialog" aria-hidden="false">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header text-bold text-center">
          提示
        </div>
        <div class="modal-body row text-break">
          <i class="col-4 fas fa-exclamation fa-5x align-self-center text-center"></i>
          <div id="modalHintContent" class="col-8 align-self-center text-bold text-secondary">
            <div>是否要重新產生 Client Id 以及 Client Secrect？</div>
            <div class="text-red mt-2">請小心使用</div>
          </div>
        </div>
        <div class="modal-footer border-0">
          <button type="button" class="btn btn-info" @click="hide">取消</button>
          <button type="button" class="btn btn-primary" @click="reset">確定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ModalList from "@/const/modal";
import { utilMixin } from "@/mixins/utilMixin";
import { mapMutations } from "vuex";
import { regenerateClientIdAndClientSecret } from "@/service/api/internal/admin/client";

export default {
  name: "ClientIdRegenerateConfirmModal",
  mixins: [utilMixin],
  data(){
    return {
      modalId: ModalList.CLIENT_ID_REGENERATE_CONFORM_MODAL,
      id: '',
      name: '',
      execFunc: null
    }
  },
  methods: {
    ...mapMutations({
      showModal:'showModal'
    }),
    show(data){
      this.id = data.id ? data.id : ''
      this.name = data.name ? data.name : ''
      this.execFunc = data.execFunc ? data.execFunc : null

      $(this.$refs[this.modalId]).modal('show')
    },
    hide(){
      $(this.$refs[this.modalId]).modal('hide')
    },
    async reset(){
      await regenerateClientIdAndClientSecret(this.id).then(res => {
        this.hide()
        if(res.status == 200){
          if(this.execFunc){
            this.execFunc()
            this.showSuccessModal({ maxCountDownSec: 3, content: `已成功重設 ${this.name}` })
          }
        }else{
          this.showErrorModal()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
